import React from 'react';
import './Scan.css';
import Fade from 'react-reveal/Fade';

const scan = (props) => {
    return (

        <div className={props.className} id="scan">
            <div class="card-body card-body-cascade text-center">
                <Fade delay={1000}>
                    <div className="circle" style={{
                        backgroundImage: "url(" + props.src + ")",
                        backgroundRepeat: "no-repeat", backgroundPosition: "50% 50%", backgroundSize: "50% 50%"
                    }} />
                </Fade>
                <br />
                <h4 class="name card-title"><Fade top>{props.name}</Fade></h4>
                <h6 class="card-text content">{props.content}</h6>
            </div>
        </div>
    )
}

export default scan;